import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import { ErrorBoundary as ErrorBoundaryComponent } from 'react-error-boundary';
import { ErrorPage } from '../../pages/error/error-page';

type ErrorBoundaryProps = {
  children: ReactNode;
};

export const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  return (
    <ErrorBoundaryComponent
      FallbackComponent={ErrorPage}
      onError={(error) => {
        Sentry.captureException(error);
      }}
    >
      {children}
    </ErrorBoundaryComponent>
  );
};
